import { render, staticRenderFns } from "./chatCard.vue?vue&type=template&id=4e391cf9&scoped=true&"
import script from "./chatCard.vue?vue&type=script&lang=js&"
export * from "./chatCard.vue?vue&type=script&lang=js&"
import style0 from "./chatCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./chatCard.vue?vue&type=style&index=1&id=4e391cf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e391cf9",
  null
  
)

export default component.exports